import { takeEvery, call, put, all, fork, select } from 'redux-saga/effects';
import { FETCH_EVENTS, PUT_EVENTS, SAVE_EVENT, CREATE_EVENT, actionCreators } from './action';
import ApiCalendar from 'react-google-calendar-api';
export function* onFetchEventsSaga(action) {

    // yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${idNewTask}`, {
    //     id: idNewTask
    // });

    

    let events = "";
    if(ApiCalendar.sign) {
        console.log('zalogowany');
        events =  yield ApiCalendar.listUpcomingEvents(72)
            .then(({ result }) => {
                const allEvents = []
                result.items.map((item) => {
                    allEvents.push(
                        { 
                            summary: item.summary, 
                            startDateTime: item.start.dateTime, 
                            colorId: item.colorId,
                            link: item.htmlLink,
                              });
                })
                return (allEvents);
            });
            console.log(events);
    }

    yield put(actionCreators.putEventsGoogleCalendar(events));
}

export function* fetchEvents() {
    yield takeEvery(FETCH_EVENTS, onFetchEventsSaga);
}

export function* googleCalendarSaga() {
	yield all([fork(fetchEvents)]);
}
